var App = App || {};

App.Video = (function ($) {
    "use strict";

    function init() {
        var $videoPlayer = $('#video-player');
        var $videoIframe = $videoPlayer.find('iframe');

        $("[data-target='video-player']").click(function () {
            $videoPlayer.modal('show');
            $videoIframe.attr('src', $(this).data('src'));
            $videoIframe.attr('title', $(this).data('title'));
        });

        $videoPlayer.on('hidden.bs.modal', event => {
            $videoIframe.attr('src', '');
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Video.init();
});